import { memo } from 'react';
import type { ReactNode } from 'react';

interface TableBodyProps {
    children: ReactNode;
}

const TableBody = ({ children }: TableBodyProps) => {
    return <tbody>{children}</tbody>;
};

/**
 * @deprecated
 * Please use `TableBody` from `@library`
 */
export default memo(TableBody);
